import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import 'react-datepicker/dist/react-datepicker.css'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/account/Login'))
const Register = React.lazy(() => import('./views/account/Register'))

const App = () => {
  const { isAuthenticated } = useSelector((state) => state.auth)

  return (
    <BrowserRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route
            exact
            path="/login"
            name="Sign in Page"
            element={isAuthenticated ? <Navigate to={'/dashboard'} /> : <Login />}
          />
          <Route
            exact
            path="/register"
            name="Sign up Page"
            element={isAuthenticated ? <Navigate to={'/dashboard'} /> : <Register />}
          />
          <Route
            path="*"
            name="Home"
            element={isAuthenticated ? <DefaultLayout /> : <Navigate to={'/login'} />}
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
